import React from "react";
import { AHText, AHIcon, AHIconType, ListItem } from "arkh";

export const StoreItem = (props: {
  label: string;
  detail: React.ReactNode;
  onPress?: () => void;
  icon?: AHIconType;
  customIcon?: React.ReactNode;
  isFirst?: boolean;
  isLast?: boolean;
}) => {
  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      color="surface"
      border="border-primary"
      right={
        <>
          <AHText type="subtitle" spaceRight="xsmall">
            {props.detail}
          </AHText>
          <ListItem.NavArrow />
        </>
      }
      left={
        props.customIcon ? (
          props.customIcon
        ) : props.icon ? (
          <AHIcon type={props.icon} />
        ) : null
      }
    >
      <ListItem.Title>{props.label}</ListItem.Title>
    </ListItem>
  );
};
